import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { IdBigCharacter } from "../../generic/big-character/IdBigCharacter";
import { ButtonPrimaryMedium } from "../../generic/common/ButtonPrimaryMedium";
import { DialogFarmEvent } from "../../generic/farm-event/DialogFarmEvent";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalSwapLast } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { PurchasePointsDetails } from "./PurchasePointsDetails";
var _DialogPurchasePointsEvent = function (_a) {
    var onGoToShopClick = _a.onGoToShopClick;
    return (React.createElement(DialogFarmEvent, { eventTitleLoca: IdLoca.purchasePointsEvent_title, eventDescriptionLoca: IdLoca.purchasePointsEvent_desc, eventCharacter: IdBigCharacter.MontgomeryPoints, eventCharacterClassName: "flex__full big-character-flip" },
        React.createElement(PurchasePointsDetails, null),
        React.createElement(ButtonPrimaryMedium, { onClick: onGoToShopClick },
            React.createElement("div", { className: "flex flex--stacked flex--guts" },
                React.createElement("div", { className: "" + IdStyles.TextBoldPrimary },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.showMe }))))));
};
var mapDispatch = function (dispatch) { return ({
    onGoToShopClick: function () { return dispatch(actionModalSwapLast(IdModal.Shop)); },
}); };
export var DialogPurchasePointsEvent = connect(undefined, mapDispatch)(_DialogPurchasePointsEvent);



//////////////////
// WEBPACK FOOTER
// ./src/features/purchase-points-event/components/DialogPurchasePointsEvent.tsx
// module id = 2885
// module chunks = 3